/**
 * en-GB messages added by Phase 1 task K3 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 * Friendly text for each printer state, for screens that show why a badge did not print (keyed `kiosk.print.state.<state>`).
 */
export const k3EnGB = {
    'kiosk.print.state.ready': 'The printer is ready',
    'kiosk.print.state.no_media': 'The printer is out of labels',
    'kiosk.print.state.cover_open': 'The printer cover is open',
    'kiosk.print.state.media_mismatch': 'The wrong labels are loaded in the printer',
    'kiosk.print.state.busy': 'The printer is busy',
    'kiosk.print.state.error': 'The printer reported a problem',
    'kiosk.print.state.unreachable': 'The printer cannot be reached',
    'kiosk.print.state.unknown': 'The printer status is not known',
};
//# sourceMappingURL=k3.js.map